<template>
  <div id="top-nav">
    <div class="top_nav_wraper">
      <div class="topnav">
        <slot></slot>
      </div>

      <slot name="topnavMenu"></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
#top-nav {
  display: flex;

  position: relative;
  left: 0;
  right: 0;
  top: 0;

  cursor: pointer; /*移入时光标样式*/
}
.top_nav_wraper {
  position: relative;
  width: 1200px;
  margin: 0px auto;
  padding: 0px 10px;
  box-sizing: border-box;
}
.topnav {
  /* height: 60PX; */

  display: flex;
  /* background-color:rgba(0, 0, 0, 0.1); */
  height: 60px;
}
</style>
